export const dailyDigestStyleOptions = ['Daily Digest', 'Hot Headlines', 'Dining Report'].map(k => ({
  key: k,
  text: k,
  value: k,
}));

export const promoAlertStyleOptions = ['Promo Alert', 'Insider Invite'].map(k => ({
  key: k,
  text: k,
  value: k,
}));

export const newsAlertStyleOptions = ['News Alert'].map(k => ({
  key: k,
  text: k,
  value: k,
}));

export const homeOfTheWeekStyleOptions = ['Homes of the Week', 'Showcase', 'Gift Guide'].map(k => ({
  key: k,
  text: k,
  value: k,
}));

// export const EMAIL_SEND_TIMES = [
//   { key: '6:50 AM', value: '06:50:00', text: '6:50 AM' },
//   { key: '6:55 AM', value: '06:55:00', text: '6:55 AM' },
//   { key: '7:00 AM', value: '07:00:00', text: '7:00 AM' },
//   { key: '7:05 AM', value: '07:05:00', text: '7:05 AM' },
//   { key: '7:10 AM', value: '07:10:00', text: '7:10 AM' },
// ];

export const EMAIL_SEND_TIMES = [
  { key: '6:45 AM', value: '06:45:00', text: '6:45 AM' },
  { key: '7:00 AM', value: '07:00:00', text: '7:00 AM' },
  { key: '7:15 AM', value: '07:15:00', text: '7:15 AM' },
  { key: '9:00 AM', value: '09:00:00', text: '9:00 AM' },
  { key: '9:30 AM', value: '09:30:00', text: '9:30 AM' },
  { key: '10:00 AM', value: '10:00:00', text: '10:00 AM' },
  { key: '10:30 AM', value: '10:30:00', text: '10:30 AM' },
  { key: '11:00 AM', value: '11:00:00', text: '11:00 AM' },
  { key: '11:30 AM', value: '11:30:00', text: '11:30 AM' },
  { key: '12:00 PM', value: '12:00:00', text: '12:00 PM' },
  { key: '12:30 PM', value: '12:30:00', text: '12:30 PM' },
];
